import type { Profile } from "@/api/bale.zod";

export const DEFAULT_PROFILE_AVATAR = "/turtle.svg";

export function profileAvatarUrl(profile: Profile) {
  return profile.avatar?.public_url ?? DEFAULT_PROFILE_AVATAR;
}

export function profileDisplayName(profile: Profile) {
  return profile.display_name ?? profile.id;
}

export function profileHasDisplayName(profile: Profile): boolean {
  return profileDisplayName(profile) !== profile.id;
}
